import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './styles'

const Avatar = ({
  userInitial,
  link,
  summaryPage,
  isHeaderMenu,
}) => {
  const users = useSelector(stateSelector => stateSelector.user)
  const getPlan = () => {
    switch (users?.subscriptionType) {
      case 'plus':
        return 'STV Player +'
      case 'premier_sports':
        return '+Premier Sports'
      default:
        return 'Free'
    }
  }

  return (
    <Fragment>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      {userInitial !== ''
        ? <a href={link} className={`avatar-button ${users?.subscriptionType || 'free'} ${summaryPage ? 'summary' : ''}`}>{!isHeaderMenu && <div className="label"><p className="text">{getPlan()}</p></div>}<span data-testid="initial">{userInitial}</span></a>
        : <div className="avatar-button" />}
      <style jsx>{styles}</style>
    </Fragment>
  )
}

Avatar.propTypes = {
  userInitial: PropTypes.string,
  link: PropTypes.string,
  summaryPage: PropTypes.bool,
  isHeaderMenu: PropTypes.bool,
}

Avatar.defaultProps = {
  summaryPage: false,
  link: '',
  userInitial: '',
  isHeaderMenu: false,
}

export default Avatar
